function l(str) {
  return _translations.hasOwnProperty(str) ? _translations[str] : str;
}

export default l;